import {
  ADD_TO_CART,
  REMOVE_ITEM,
  SUB_QUANTITY,
  ADD_QUANTITY,
  FETCH_CONTENT,
  RESET_CART,
} from "./actionTypes";

export function updateContent(content, images) {
  return {
    type: FETCH_CONTENT,
    ...(content
      ? {
          content: content,
        }
      : {}),
    ...(images
      ? {
          images: images,
        }
      : {}),
  };
}
export const addToCart = (product, item) => {
  return {
    type: ADD_TO_CART,
    product,
    item,
  };
};

export const removeItem = (product, item) => {
  return {
    type: REMOVE_ITEM,
    product,
    item,
  };
};
export const addQuantity = (product, item) => {
  return {
    type: ADD_QUANTITY,
    product,
    item,
  };
};
export const substractQuantity = (product, item) => {
  return {
    type: SUB_QUANTITY,
    product,
    item,
  };
};

export const resetCart = () => {
  return {
    type: RESET_CART,
  };
};
